<template>
  <v-card-text class="subheading text-left">
    <v-row no-gutters align="center" justify="center">
      <v-col cols="12" md="3" class="pr-md-4">
        <v-img
          v-if="!avatar"
          :src="NotAvatar"
          :max-height="$vuetify.display.smAndUp ? 350 : 190"
          :aspect-ratio="1"
          class="ma-5"
        ></v-img>
        <v-img
          v-else
          :src="avatar"
          :max-height="$vuetify.display.smAndUp ? 350 : 190"
          :lazy-src="NotAvatar"
          :aspect-ratio="1"
          class="ma-5"
        ></v-img>
      </v-col>
      <v-col cols="12" md="9">
        <v-row :class="(col % 2) ? 'pa-3 bg-grey-lighten-3 rounded-lg' : 'pa-3 rounded-lg'"
               v-for="(col, i) in Object.keys(fields)" :key="`row${i}_${col}`" no-gutters>
          <v-col class="text-left">
            <b class="font-weight-black">{{ fields[col].text }}:</b>
          </v-col>
          <v-col class="text-right text-sm-left">
              <span
                v-if="fields[col].type">
                {{
                  displayDate(user[fields[col].field], fields[col].type === 'datetime')
                }}
              </span>
            <span v-else>
                <span v-if="user[fields[col].field] !== 'null'">{{ user[fields[col].field] }}</span>
              </span>
          </v-col>
        </v-row>
        <slot name="forms" v-bind:abc="avatar"/>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import NotAvatar from "@/assets/NotAvatar.png";
import { displayDate } from "@/helper";

export default {
  data () {
    return {
      NotAvatar
    }
  },
  props: {
    avatar: {
      type: String,
      required: true,
    },
    fields: {
      type: Array,
      default: () => []
    },
    user: {
      type: Object,
      required: true,
    },
  },
  methods: {
    displayDate
  }
}
</script>
